module.exports = __webpack_public_path__ + "images/speed-five-active.24d92463cbb2e706fad55beb483a562f.png";